import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import SinglePhotoManager from './SinglePhotoManager';
import * as Icons from '../icons/Icons';

export default class HeroImage extends React.Component {
    static propTypes = {
        originalImage: PropTypes.object,
        croppedImage: PropTypes.object,
        altText: PropTypes.string,
        caption: PropTypes.string,
        credit: PropTypes.string,
        hasHeroImage: PropTypes.bool,
        uploadManager: PropTypes.object.isRequired,
        getHeroImage: PropTypes.func.isRequired,
        onPublish: PropTypes.func,
        onDelete: PropTypes.func
    };

    static defaultProps = {
        originalImage: {},
        croppedImage: {},
        altText: '',
        caption: '',
        credit: '',
        hasHeroImage: false,
        onPublish: () => {},
        onDelete: () => {}
    };

    state = {
        isHelpModalOpen: false
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.originalImage.source !== this.props.originalImage.source ||
            nextProps.croppedImage.source !== this.props.croppedImage.source ||
            nextProps.altText !== this.props.altText ||
            nextProps.caption !== this.props.caption ||
            nextProps.credit !== this.props.credit ||
            nextProps.hasHeroImage !== this.props.hasHeroImage ||
            nextState.isHelpModalOpen !== this.state.isHelpModalOpen
        ) {
            return true;
        }
        return false;
    }

    toggleHelpModal = (e) => {
        e.preventDefault();
        this.setState({ isHelpModalOpen: !this.state.isHelpModalOpen });
    };

    render() {
        const { isHelpModalOpen } = this.state;

        return (
            <div className="rec-photo-upload-page-section">
                <h2 className="rec-photo-upload-page-section-heading">
                    <button
                        className="rec-photo-upload-page-section-helptip-trigger"
                        aria-label="Open information about the hero image"
                        onClick={this.toggleHelpModal}>
                        Preview Image <Icons.IconInfo alt="" />
                    </button>
                </h2>

                <SinglePhotoManager id="preview" imageType="preview" imageTypeDisplay="Preview Image" desiredWidth={700} desiredHeight={524} {...this.props} />

                {isHelpModalOpen && (
                    <Modal
                        role="complementary"
                        className="rec-photo-help-modal"
                        overlayClassName="rec-overlay-base rec-overlay-after-open"
                        isOpen={isHelpModalOpen}
                        onRequestClose={this.toggleHelpModal}>
                        <div className="rec-photo-help-modal-inner">
                            <h2>Preview Image</h2>
                            <div className="rec-photo-help-modal-content">
                                <div className="rec-photo-help-modal-left-col">
                                    <img src={`${process.env.CDN}/img/photo-manager/preview-img-example.jpg`} alt="example hero" />
                                </div>
                                <div className="rec-photo-help-modal-right-col">
                                    <p>
                                        After you&rsquo;ve added a hero image for your location, you&rsquo;ll need to select your preview image. The preview
                                        image is a smaller-scale promotional image of your location that appears next to your inventory description in search
                                        results on the website.
                                    </p>
                                    <p>
                                        Our photo tool provides the option to upload a separate preview image or use the same photo as your hero image. You can
                                        click the &ldquo;Upload Promo Image&rdquo; button to add a new preview image or the &ldquo;Use the Hero Image&rsquo;
                                        button to reapply the hero image and information provided in the previous section for your promotional photo. You can
                                        also edit or refocus your preview image using the cropping tool. If you choose to upload a different preview image,
                                        please ensure you add alternative text, caption text, and source information for the photo.
                                    </p>
                                </div>
                            </div>

                            <div className="rec-photo-help-modal-buttons">
                                <button className="rec-button-primary" onClick={this.toggleHelpModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        );
    }
}
